<template>
    <v-row class="pt-12 justify-center padding-bottom-150 align-center">
        <span class="head-number pr-12">404</span>
        <span class="back-number text-underline pr-12 pt-12">404</span>
        <v-divider vertical class="main--yellow height-200 mt-10"></v-divider>
        <v-col cols="12" xs="12" sm="4" class="align-center pl-12">
            <span class="display-1">УПС!</span>
            <p class="text-left headline font-weight-regular py-8 pt-sm-0 ma-0">{{ $t('notExistingPage') }}</p>
            <v-btn
                depressed
                large
                class="body-2 px-10 main--yellow test-white font-weight-medium"
                to="/"
                outlined
            >{{ $t('mainPage') }}
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
    import './not-found.scss';

    export default {
        name: "NotFound"
    }
</script>

<style scoped>

</style>
